export default "/images/cfc64e027efba245b4254ee0c8647626.avif";